/**
 * Company: LifeAI, Copyright 2018, All Rights Reserved.
 * Author: Pavel Kostenko
 * Email: poul.kg@gmail.com
 * Date: 9/14/18
 * Time: 15:20
 */
import {Injectable} from '@angular/core';

@Injectable()
export class LaIconService {
  private _icons = [
    'activity',
    'add-resource',
    'add-user',
    'add',
    'apps',
    'archive',
    'arrow-down',
    'assets',
    'attachment',
    'back',
    'bank',
    'bell-ringing',
    'bell',
    'bike',
    'book-address',
    'bookings',
    'building',
    'business',
    'calendar-favorite',
    'car',
    'checkmark',
    'city-buildings',
    'clock-sync',
    'compose',
    'credit-card',
    'credits',
    'dashboard',
    'delete',
    'desktop',
    'door',
    'download',
    'duplicate',
    'edit',
    'email',
    'event',
    'exit',
    'extras',
    'facebook',
    'file-csv',
    'file-pdf',
    'floater',
    'folder',
    'forward',
    'globe',
    'help',
    'home',
    'hyperlink',
    'import',
    'info',
    'invoices',
    'key',
    'linkedin',
    'location-pin',
    'lock',
    'mark-paid',
    'meeting-room',
    'merge',
    'messages',
    'mobile',
    'new-message',
    'newspaper',
    'next',
    'people',
    'phone',
    'photos',
    'plane',
    'plans',
    'remove',
    'resources',
    'search',
    'settings',
    'share',
    'sort',
    'subtract',
    'suite',
    'support',
    'sync',
    'time',
    'twitter',
    'unarchive',
    'visibility-hidden',
    'visibility',
    'pin',
    'megaphone',
    'arrow-up',
    'filter',
    'font-size',
    'paragraph',
    'balloon'
  ];

  constructor() {
  }

  getIconNames(): string[] {
    return this._icons;
  }
}
